import { ExcelExportArgs } from "@medapro-types/services/excelEdit";
import api from "./api";
import endpoints from "./endpoints";

export default {
  exportExcelEdit: async function (args: ExcelExportArgs) {
    const response = await api.post(endpoints.excelEdit.export, args);
    return response.data;
  },
  excelImport: async function name(file: File, signal: AbortSignal) {
    const response = await api.post(
      endpoints.excelEdit.import,
      { file },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        signal: signal
      }
    );
    return response.data;
  },
  getExportDataTypes: async function () {
    const response = await api.get(endpoints.excelEdit.GetExportDataTypes);
    return response.data;
  },
  getMamParameterTypes: async function () {
    const response = await api.get(endpoints.excelEdit.GetMamParameterTypes);
    return response.data;
  },
  getAttributeGroupsOfCatalogNode: async function (catalogId: string, nodeId: string, languageCode: string) {
    const response = await api.get(endpoints.excelEdit.GetAttributeGroupsOfCatalogNode, { params: { catalogId, nodeId, language: languageCode } });
    return response.data;
  },
  getAttributeGroupsOfAdvancedSearch: async function (catalogId: string, advancedSearchId: string, languageCode: string) {
    const response = await api.get(endpoints.excelEdit.GetAttributeGroupsOfAdvancedSearch, { params: { catalogId, advancedSearchId, language: languageCode } });
    return response.data;
  },
  exportAdvancedSearchExcelEdit: async function (advancedSearchId: string, args: ExcelExportArgs) {
    const response = await api.post(endpoints.excelEdit.exportAdvancedSearch, args, { params: { advancedSearchId } });
    return response.data;
  }
};
